import { render } from "./ShoppingList.vue?vue&type=template&id=360ea465"
import script from "./ShoppingList.vue?vue&type=script&lang=js"
export * from "./ShoppingList.vue?vue&type=script&lang=js"

import "./ShoppingList.vue?vue&type=style&index=0&id=360ea465&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__